import { Component, Input, OnInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { MdbChartDirective } from 'mdb-angular-ui-kit/charts';
import { ComponentBase } from 't4core';
import * as moment from 'moment';



@Component({
    selector: 'u4f-revenue-chart',
  templateUrl: 'revenueChart.html',
})
export class RevenueChartWidget extends ComponentBase implements OnInit, OnChanges {

    @ViewChild(MdbChartDirective, {static: false}) chartControl: MdbChartDirective;
    @Input() title: string = "";
    @Input() revenueCY: string = "";
    @Input() revenuePY: string = "";
    @Input() fromDate: moment.Moment = moment().startOf('month');
    @Input() toDate: moment.Moment = moment().endOf('month');
    public isLoading: boolean = false;
    private isInitializing: boolean = true;
    constructor() {
        super();
    }

  public async ngOnInit() {
    await this.loadData();
    this.isInitializing = false;
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (this.isInitializing) return;
    if (changes.fromDate || changes.toDate) {
      setTimeout(async () => {
        await this.loadData();
      }, 250);
    }
  }

  public async loadData() {
    this.isLoading = true;
        var month = new Date().getMonth();
        //this.chartLabels = this.chartLabels.slice(month).concat(this.chartLabels.slice(0, month));

    var x = await this.Api.get<number[]>("/U4FDashboard/GetU4FRevenuePreviousYear");
        this.chartDatasets[1] = {
            yAxisID: "y-axis-0",
            data: x,
            label: this.revenuePY,
            backgroundColor: 'rgba(0,0,0,0)',
            borderColor: 'rgba(0,0,0,0.5)',
            lineTension: 0.35
        };

    var y = await this.Api.get<number[]>("/U4FDashboard/GetU4FRevenueCurrentYear");
        this.chartDatasets[0    ] = {
            yAxisID: "y-axis-0",
            data: y,
            label: this.revenueCY,
            backgroundColor: 'rgba(151,187,205,0.2)',
            borderColor: 'rgba(151,187,205,1)',
            lineTension: 0.35
        };

    this.chartControl.update();
    this.isLoading = false;
    }

    public chartType: string = 'line';

    public chartDatasets: Array<any> = [{}, {}];

    public chartLabels: Array<any> = ['Jan','Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'];

    public chartOptions: any = {
        responsive: true,
      scales: {
        y: {
          stacked: false,
          position: "left",
          id: "y-axis-0",
          ticks: {
            display: false
          }
        }
      },
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)'
      ],
      borderColor: [
        'rgba(255,99,132,1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)'
      ],
    };

    public chartClicked(e: any): void {

    }

    public chartHovered(e: any): void {

    }
}
